import { generateApiKeyId } from 'dashboard/lib/stubs/api-key';
import {
  Environment,
  EnvironmentAttributes,
  EnvironmentStatus,
} from 'dashboard/models/environment';
import { ApiModel } from 'lib/interfaces/api';

export function createPreviewEnvironmentProduction(
  attributes?: Partial<EnvironmentAttributes>,
): Environment {
  return {
    attributes: {
      name: 'Production',
      'workflow-secret-key': 'persona_production_123-abc',
      status: EnvironmentStatus.Active,
      quotas: [],
      ...attributes,
    },
    type: ApiModel.EnvironmentProduction,
    id: 'env_production',
    relationships: {
      'api-keys': { data: [{ id: generateApiKeyId(), type: ApiModel.ApiKey }] },
    },
  };
}
